import React, { useState, useRef } from 'react';
import { isTouchDevice } from '../hooks/useBreakpoint';

export default function QuickAdd({ onAdd, pipeline }) {
  const [firm,    setFirm]    = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();

  const label = pipeline === 'Investor' ? 'Investor Outreach' : 'Partner Outreach';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firm.trim()) return;
    setLoading(true);
    try {
      await onAdd(firm.trim());
      setFirm('');
      inputRef.current?.focus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="quick-add" onSubmit={handleSubmit} style={{
      display: 'flex', gap: 8, marginBottom: 14,
      background: 'var(--bg-card)',
      border: '1px solid var(--primary-border)',
      borderRadius: 'var(--radius)',
      padding: '10px 14px', alignItems: 'center',
    }}>
      <span className="quick-add-label" style={{
        fontFamily: 'Sora, sans-serif', fontSize: 12, fontWeight: 600,
        color: 'var(--primary)', whiteSpace: 'nowrap',
        textTransform: 'uppercase', letterSpacing: '0.08em',
      }}>
        Quick Add · {label}
      </span>
      <input
        ref={inputRef} type="text" value={firm}
        className="quick-add-input"
        onChange={e => setFirm(e.target.value)}
        placeholder="Firm name…" autoFocus={!isTouchDevice()}
        style={{
          flex: 1, background: 'var(--bg-card2)',
          border: '1px solid var(--border-med)',
          borderRadius: 'var(--radius-sm)', color: 'var(--text)',
          padding: '6px 12px', fontSize: 13,
          fontFamily: 'DM Sans, sans-serif', outline: 'none',
        }}
        onFocus={e => e.target.style.borderColor = 'var(--primary)'}
        onBlur={e => e.target.style.borderColor = 'var(--border-med)'}
      />
      <button type="submit" className="quick-add-btn" disabled={!firm.trim() || loading} style={{
        background: firm.trim() && !loading
          ? 'linear-gradient(135deg, var(--primary), var(--primary-dark))'
          : 'var(--bg-card2)',
        border: 'none', borderRadius: 'var(--radius-sm)',
        color: firm.trim() && !loading ? '#fff' : 'var(--text-dim)',
        fontFamily: 'DM Sans, sans-serif', fontWeight: 600, fontSize: 13,
        padding: '6px 20px', cursor: firm.trim() && !loading ? 'pointer' : 'not-allowed',
        whiteSpace: 'nowrap',
      }}>
        {loading ? '…' : '+ Add'}
      </button>
    </form>
  );
}